// Vehicle Prompt Templates - Midjourney Style
// 50 epische Auto-Szenarien für kreative Generationen

export const VEHICLE_PROMPT_TEMPLATES = [
  // Bergstraßen & Alpen
  {
    short: "Alpenstraße, Sonnenuntergang, dramatische Gipfel",
    full: "auf kurvenreicher Alpenstraße fahrend, goldener Sonnenuntergang, dramatische schneebedeckte Gipfel, epische Landschaft, cinematic lighting"
  },
  {
    short: "Dolomiten Pass, Morgennebel, steile Serpentinen",
    full: "auf Dolomiten-Pass, mystischer Morgennebel zwischen Felsen, steile Serpentinen, atemberaubende Aussicht, ethereal atmosphere"
  },
  {
    short: "Schweizer Alpen, Gletscher, Panoramastraße",
    full: "auf Schweizer Panoramastraße, majestätische Gletscher im Hintergrund, kristallklare Luft, epic mountain vista, professional automotive photography"
  },
  
  // Wüsten & Desert
  {
    short: "Sahara Dünen, goldene Stunde, endlose Weite",
    full: "in Sahara-Wüste, goldene Sanddünen bei Sonnenuntergang, endlose Weite, warmes Licht, cinematic desert shot, dramatic shadows"
  },
  {
    short: "Arizona Monument Valley, rote Felsen, staubig",
    full: "in Arizona Monument Valley, ikonische rote Felsformationen, staubige Straße, golden hour, epic American Southwest landscape"
  },
  {
    short: "Dubai Wüste, Luxus, Sandsturm, dramatisch",
    full: "in Dubai-Wüste, approaching Sandsturm, dramatische Wolken, luxuriöses Setting, moody atmosphere, cinematic tension"
  },
  {
    short: "Death Valley, Hitzeflimmern, karge Landschaft",
    full: "in Death Valley Kalifornien, Hitzeflimmern auf Straße, karge Landschaft, intensives Sonnenlicht, desolate beauty, dramatic composition"
  },
  
  // Küsten & Meer
  {
    short: "Amalfiküste, türkisblaues Meer, Küstenstraße",
    full: "auf Amalfiküste-Straße, türkisblaues Meer unten, bunte Häuser an Klippen, mediterranes Flair, dreamy coastal vibes"
  },
  {
    short: "California Highway 1, Pazifik, Klippen, Sonnenuntergang",
    full: "auf Pacific Coast Highway, dramatische Klippen, Pazifik-Brandung, goldenener Sonnenuntergang, iconic California road trip"
  },
  {
    short: "Norwegen Atlantikstraße, stürmische See, Brücken",
    full: "auf Norwegischer Atlantikstraße, stürmische See, spektakuläre Brücken, moody clouds, epic Nordic landscape"
  },
  {
    short: "Miami Beach, Art Deco, Palmen, Ozean",
    full: "an Miami South Beach, Art Deco Gebäude, Palmen, türkiser Ozean, vibrant colors, retro glamour vibes"
  },
  
  // Städte & Urban
  {
    short: "Manhattan Skyline, nachts, Wolkenkratzer, Lichter",
    full: "vor Manhattan Skyline, nächtliche Wolkenkratzer, funkelnde Lichter, reflektierende Straßen, urban sophistication, cinematic city shot"
  },
  {
    short: "Tokyo Shibuya, Neonlichter, Regen, Cyberpunk",
    full: "in Tokyo Shibuya bei Regen, bunte Neonlichter reflektierend, Cyberpunk-Atmosphäre, futuristic urban setting, blade runner vibes"
  },
  {
    short: "Dubai Downtown, Burj Khalifa, Luxus, nachts",
    full: "vor Burj Khalifa Dubai, luxuriöse Umgebung, nächtliche Beleuchtung, moderne Architektur, opulent cityscape, premium aesthetic"
  },
  {
    short: "London Westminster, Big Ben, regnerisch, klassisch",
    full: "an Westminster Bridge London, Big Ben im Hintergrund, regnerischer Abend, klassische britische Atmosphäre, moody European elegance"
  },
  {
    short: "Las Vegas Strip, Casino-Lichter, nachts, glamourös",
    full: "am Las Vegas Strip, Casino-Lichter überall, nächtlicher Glamour, vibrant energy, neon paradise, electric atmosphere"
  },
  
  // Rennstrecken & Action
  {
    short: "Formel 1 Rennstrecke, Boxengasse, Sonnenlicht",
    full: "auf Formel 1 Rennstrecke, Boxengasse, professionelles Motorsport-Setting, hartes Sonnenlicht, racing heritage, performance aesthetic"
  },
  {
    short: "Nürburgring Nordschleife, Kurven, Action, Speed",
    full: "auf Nürburgring Nordschleife, legendäre Kurven, Action-Szene, Speed, motorsport mecca, adrenaline rush, dynamic composition"
  },
  {
    short: "Drift-Arena, Rauch, Reifen quietschen, Performance",
    full: "in Drift-Arena, Rauch von Reifen, Action-Moment, Performance-Atmosphäre, high-octane energy, motorsport intensity"
  },
  {
    short: "Monaco Grand Prix Strecke, Casino, mediterran",
    full: "auf Monaco Grand Prix Strecke, Casino im Hintergrund, mediterrane Atmosphäre, Luxus-Motorsport, prestigious racing heritage"
  },
  
  // Natur & Landschaft
  {
    short: "Schottland Highlands, Seen, grüne Hügel, mystisch",
    full: "in Schottischen Highlands, tiefblaue Seen, grüne Hügel, mystischer Nebel, Celtic beauty, ethereal landscape"
  },
  {
    short: "Neuseeland Fjorde, Berge, Wasserfälle, episch",
    full: "an Neuseeland-Fjorden, majestätische Berge, Wasserfälle, epische Natur, untouched wilderness, breathtaking scenery"
  },
  {
    short: "Island Ringstraße, Vulkane, schwarzer Sand",
    full: "auf Island Ringstraße, aktive Vulkane, schwarze Sandstrände, otherworldly landscape, raw Nordic power"
  },
  {
    short: "Kanadische Rockies, Banff, türkise Seen, Kiefern",
    full: "in Kanadischen Rockies bei Banff, türkise Bergseen, Kiefernwälder, pristine nature, majestic Canadian wilderness"
  },
  {
    short: "Toskana Hügel, Zypressen, Weinberge, Sonnenuntergang",
    full: "auf Toskana-Hügeln, Zypressen-Alleen, Weinberge, goldener Sonnenuntergang, Italian countryside dream, romantic atmosphere"
  },
  
  // Winter & Schnee
  {
    short: "Alpen Winter, verschneit, Gletscher, klare Luft",
    full: "auf verschneiter Alpenstraße, Gletscher rundherum, kristallklare Winterluft, powder snow, pristine winter wonderland"
  },
  {
    short: "Lappland Nordlichter, Schnee, Aurora, magisch",
    full: "in Lappland unter Nordlichtern, verschneite Landschaft, Aurora Borealis, magische Atmosphäre, arctic dreamscape"
  },
  {
    short: "Whistler Mountain Road, Schneefall, Kiefern",
    full: "auf Whistler Mountain Road, leichter Schneefall, verschneite Kiefern, alpine winter beauty, cozy mountain atmosphere"
  },
  
  // Strand & Tropical
  {
    short: "Maldiven Strand, weißer Sand, Palmen, türkis",
    full: "am Maldiven-Strand, puderzuckerweißer Sand, Palmen, türkisfarbenes Wasser, tropical paradise, luxury beach vibes"
  },
  {
    short: "Bali Reisfelder, grün, Terrassen, tropisch",
    full: "an Bali-Reisterrassen, sattgrüne Felder, tropische Atmosphäre, exotic Indonesian beauty, serene landscape"
  },
  {
    short: "Hawaii Vulkanstraße, schwarzer Fels, Ozean",
    full: "auf Hawaii Vulkan-Küstenstraße, schwarzer Lavafels, Pazifik-Brandung, dramatic volcanic landscape, raw island power"
  },
  
  // Architektur & Modern
  {
    short: "Futuristisches Gebäude, Glas, Stahl, modern, minimalistisch",
    full: "vor futuristischer Architektur, Glas und Stahl, minimalistisches Design, moderne Stadt, architectural masterpiece, sci-fi aesthetics"
  },
  {
    short: "Brutalist Building, Beton, geometrisch, urban",
    full: "vor Brutalist-Gebäude, roher Beton, geometrische Formen, urban grit, architectural statement, industrial beauty"
  },
  {
    short: "Moderne Villa, Pool, Luxus, Clean, Architektur",
    full: "vor moderner Villa, Infinity-Pool, luxuriöses Design, clean lines, contemporary architecture, minimalist luxury"
  },
  
  // Historisch & Klassisch
  {
    short: "Schloss Neuschwanstein, Bayern, Märchen, Wald",
    full: "vor Schloss Neuschwanstein, bayerische Alpen, Märchen-Atmosphäre, Wald, fairytale castle setting, romantic heritage"
  },
  {
    short: "Römisches Kolosseum, antike Ruinen, golden hour",
    full: "am Römischen Kolosseum, antike Steinbögen, golden hour Beleuchtung, historic grandeur, timeless Italian heritage"
  },
  {
    short: "Pariser Champs-Élysées, Arc de Triomphe, elegant",
    full: "auf Champs-Élysées Paris, Arc de Triomphe, elegante Boulevards, klassische Pariser Eleganz, European sophistication"
  },
  
  // Action & Dynamik
  {
    short: "Burnout, Rauch, Performance, Action, Reifen",
    full: "beim Burnout, massiver Rauch von Reifen, Action-Moment, Performance, high-energy scene, motorsport intensity"
  },
  {
    short: "Sprung über Düne, Wüsten-Rally, Action, Sand",
    full: "beim Sprung über Sanddüne, Wüsten-Rally, spektakuläre Action, Sand spritzend, desert rally madness, extreme sports energy"
  },
  {
    short: "Driften Bergpass, Kurven, Rauch, Adrenalin",
    full: "beim Driften auf Bergpass, enge Kurven, Rauch von Reifen, Adrenalin, mountain drift mastery, controlled chaos"
  },
  
  // Nacht & Lichter
  {
    short: "City Lights, nachts, nass reflektierend, neon",
    full: "in nächtlicher Stadt, nasse Straßen reflektierend, bunte Neon-Lichter, urbane Nacht-Atmosphäre, cyberpunk nights, electric city vibes"
  },
  {
    short: "Autobahn nachts, Lichter, Langzeitbelichtung, Speed",
    full: "auf Autobahn nachts, Lichtspuren, Langzeitbelichtung-Effekt, Speed, dynamic night drive, motion blur aesthetics"
  },
  {
    short: "Parkhaus nachts, Neon-Beleuchtung, urban, cool",
    full: "in Parkhaus nachts, Neon-Streifen-Beleuchtung, urbane Atmosphäre, cool vibe, underground car culture, moody lighting"
  },
  
  // Extreme Locations
  {
    short: "Gletscher Island, Eis, unwirtlich, dramatisch",
    full: "auf Gletscher in Island, massive Eisformationen, unwirtliche Landschaft, dramatisches Licht, extreme arctic expedition, raw natural power"
  },
  {
    short: "Salar de Uyuni Bolivien, Salzsee-Spiegel, surreal",
    full: "auf Salar de Uyuni Salzsee, perfekte Spiegelung im Wasser, surreale Atmosphäre, Wolken reflektierend, dreamlike Bolivian salt flats"
  },
  {
    short: "Nordkap Norwegen, Mitternachtssonne, Klippen",
    full: "am Nordkap Norwegen, Mitternachtssonne am Horizont, steile Klippen, Nordmeer, midnight sun magic, edge of the world"
  },
  
  // Jungle & Forest
  {
    short: "Regenwald Costa Rica, tropisch, grün, Dschungel",
    full: "auf Dschungelstraße in Costa Rica, dichter Regenwald, sattgrünes Blätterdach, tropische Atmosphäre, jungle adventure, lush rainforest"
  },
  {
    short: "Sequoia Nationalpark, Mammutbäume, Schatten",
    full: "zwischen Sequoia-Mammutbäumen, filtered sunlight, majestätische Schatten, ancient forest, Cathedral of giants"
  },
  
  // Industrie & Urban Grit
  {
    short: "Industriegebiet, Fabrik, Rauch, gritty, urban",
    full: "in Industriegebiet, alte Fabrikgebäude, Rauch, gritty urban atmosphere, industrial decay, raw city edge"
  },
  {
    short: "Containerterminal, Hafen, Kräne, geometrisch",
    full: "im Containerterminal Hafen, massive Kräne, geometrische Container, industrial scale,港口 港 aesthetic, logistics poetry"
  },
  {
    short: "Lost Place Fabrik, verlassen, mysteriös, düster",
    full: "vor verlassener Fabrik, Lost Place, mysteriöse Stimmung, düsteres Licht, urban exploration, forgotten industrial past"
  },
  
  // Premium & Luxus
  {
    short: "Monaco Casino, Luxus, Nacht, Glamour, Lichter",
    full: "vor Monaco Casino, luxuriöse Umgebung, nächtliche Beleuchtung, Glamour, opulent Riviera lifestyle, sophisticated elegance"
  },
  {
    short: "Beverly Hills, Palmen, Luxusvillen, Sonnenschein",
    full: "in Beverly Hills, Palmen-Alleen, Luxusvillen, kalifornischer Sonnenschein, LA dream lifestyle, Hollywood glamour"
  },
  {
    short: "Yacht Marina, Luxusyachten, Sonnenuntergang, Premium",
    full: "an exklusiver Yacht-Marina, Luxusyachten, goldener Sonnenuntergang, Premium-Atmosphäre, maritime luxury, coastal sophistication"
  },
  {
    short: "Private Flughafen, Privatjet, Luxus, modern",
    full: "an privatem Flughafen, Privatjets, luxuriöse Umgebung, moderne Architektur, elite travel lifestyle, aviation luxury"
  },
  
  // Regen & Wetter
  {
    short: "London Regen, nasse Straßen, Reflexionen, moody",
    full: "in London bei Regen, nasse Straßen mit Spiegelungen, moody atmosphere, graue Wolken, British weather aesthetics, melancholic beauty"
  },
  {
    short: "Gewitter, Blitze, dramatisch, dunkle Wolken",
    full: "bei Gewitter, Blitze am Himmel, dramatische dunkle Wolken, elektrische Spannung, storm chasing aesthetics, nature's fury"
  },
  {
    short: "Nebel Waldstraße, mystisch, Bäume, Sichtweite gering",
    full: "auf nebliger Waldstraße, mystische Stimmung, Bäume im Nebel, geringe Sichtweite, mysterious forest drive, ethereal mist"
  },
  
  // Retro & Vintage
  {
    short: "Route 66, Retro Diner, 50er Jahre, Americana",
    full: "an klassischem Route 66 Diner, 50er Jahre Americana, Retro-Schilder, nostalgische Atmosphäre, vintage road trip, American dream"
  },
  {
    short: "Drive-In Kino, Retro, Sonnenuntergang, nostalgisch",
    full: "im Drive-In Kino, Retro-Leinwand, Sonnenuntergang, nostalgische 60er Vibes, classic American pastime, golden age of cinema"
  },
  {
    short: "Tankstelle 50er Jahre, Vintage, Werbung, klassisch",
    full: "an 50er Jahre Tankstelle, Vintage-Zapfsäulen, klassische Reklame, nostalgische Ära, retro service station, Americana heritage"
  },
  
  // Exotisch & International
  {
    short: "Marokko Marrakesch, Medina, orientalisch, bunt",
    full: "in Marrakesch Medina, orientalische Architektur, bunte Souks, exotische Atmosphäre, Moroccan mystique, ancient market charm"
  },
  {
    short: "Santorini Griechenland, weiße Häuser, blaue Kuppeln",
    full: "in Santorini, weiße Kykladenhäuser, blaue Kuppeln, Ägäisches Meer, Greek island paradise, postcard perfection"
  },
  {
    short: "Dubai Mall, Luxus-Shopping, modern, Brunnen",
    full: "vor Dubai Mall, luxuriöses Shopping-Center, moderne Architektur, Wasserspiele, opulent retail palace, Middle Eastern luxury"
  },
  
  // Minimalistisch & Clean
  {
    short: "Weiße Wand, minimalistisch, clean, Studio, modern",
    full: "vor weißer minimalistischer Wand, Studio-Setting, clean aesthetic, moderne Schlichtheit, purist photography, timeless simplicity"
  },
  {
    short: "Salzwüste, endlose Weite, weiß, surreal, minimalistisch",
    full: "auf weißer Salzwüste, endlose Ebene, surreale Minimalismus, klarer Himmel, infinite white expanse, zen-like purity"
  },
  {
    short: "Moderne Tiefgarage, clean, Linien, geometrisch",
    full: "in moderner Tiefgarage, cleane Linien, geometrische Architektur, minimalistisches Design, urban geometry, architectural precision"
  },
  
  // Sonnenauf/untergang
  {
    short: "Golden Hour Feld, Kornfeld, warm, friedlich",
    full: "an Kornfeld bei Golden Hour, warmes Licht, friedliche Landschaft, sanfte Hügel, pastoral serenity, countryside magic"
  },
  {
    short: "Sonnenaufgang am See, Nebel, Spiegelung, ruhig",
    full: "am See bei Sonnenaufgang, Morgennebel, perfekte Spiegelung im Wasser, ruhige Atmosphäre, tranquil dawn, mirror-like stillness"
  },
  {
    short: "Sunset Boulevard LA, Palmen, pink sky, Kalifornien",
    full: "am Sunset Boulevard LA, Palmen-Silhouetten, pinker Himmel, kalifornisches Sunset-Flair, LA dreams, West Coast golden hour"
  },
  
  // Sci-Fi & Futuristisch
  {
    short: "Cyberpunk Stadt, Neon, Hochhäuser, futuristisch",
    full: "in Cyberpunk-Metropole, Neon-Wolkenkratzer, futuristische Architektur, Sci-Fi Atmosphäre, blade runner aesthetic, neon-soaked future"
  },
  {
    short: "Weltraumstation, Sci-Fi, futuristisch, Sterne",
    full: "vor futuristischer Weltraumstation, Sternenhimmel, Sci-Fi Setting, space age aesthetics, cosmic frontier, interstellar vision"
  },
  {
    short: "Hologramm-Stadt, digital, Matrix, virtuell",
    full: "in holografischer Stadt, digitale Projektion, Matrix-Style, virtuelle Welt, digital realm, cyber reality, metaverse aesthetics"
  },
  
  // Abenteuer & Exploration
  {
    short: "Outback Australien, rot, staubig, Weite, Adventure",
    full: "im Australischen Outback, roter Staub, endlose Weite, Abenteuer-Stimmung, rugged frontier, untamed wilderness"
  },
  {
    short: "Atacama Wüste Chile, Mars-ähnlich, surreal, trocken",
    full: "in Atacama-Wüste Chile, Mars-ähnliche Landschaft, surreal, trockenste Wüste der Welt, otherworldly terrain, alien landscape"
  },
  {
    short: "Patagonien Gletscher, Argentinien, Eis, wild",
    full: "in Patagonien, massive Gletscher, wilde Natur, raues Klima, edge of civilization, pristine southern wilderness"
  },
  
  // Luxus-Destinationen
  {
    short: "St. Moritz, Schweiz, Schnee, Luxus, Ski-Resort",
    full: "in St. Moritz Schweiz, verschneites Luxus-Ski-Resort, alpine Eleganz, premium winter destination, Swiss sophistication"
  },
  {
    short: "Côte d'Azur, Riviera, Luxus, mediterranes Flair",
    full: "an der Côte d'Azur, französische Riviera, luxuriöses mediterranes Flair, azure coast, Riviera elegance, summer sophistication"
  },
  {
    short: "Bodensee, Alpen, Seeufer, idyllisch, friedlich",
    full: "am Bodensee-Ufer, Alpen-Panorama, idyllische Seelandschaft, friedlich, lakeside serenity, Alpine lake paradise"
  },
  
  // Special Effects
  {
    short: "Rauch-Show, Nebel, dramatisch, mystisch, Show",
    full: "in Rauch-Show, dichter Nebel, dramatisches Licht, mystische Atmosphäre, theatrical smoke display, cinematic drama"
  },
  {
    short: "Neon-Tunnel, Lichter, futuristisch, Speed, Farben",
    full: "in Neon-Tunnel, bunte Lichtröhren, futuristischer Speed-Effekt, intensive Farben, hyperspace vibes, light speed aesthetics"
  },
  {
    short: "Sternenhimmel Milchstraße, Nacht, Astro, klar",
    full: "unter Milchstraße, klarer Sternenhimmel, Astro-Fotografie-Setting, Nacht, cosmic wonder, celestial beauty"
  },
  {
    short: "Feuerwerk Silvester, Stadt, Lichter, festlich",
    full: "bei Silvester-Feuerwerk, Stadt-Skyline, bunte Lichter am Himmel, festliche Atmosphäre, New Year celebration, explosive joy"
  },
  
  // Jahreszeiten
  {
    short: "Herbstwald, bunte Blätter, golden, Laub, warm",
    full: "in Herbstwald, bunt gefärbte Blätter, goldenes Laub, warme Herbstfarben, autumn foliage, fall color symphony"
  },
  {
    short: "Frühlingswiese, Blumen, grün, frisch, lebendig",
    full: "auf Frühlingswiese, bunte Wildblumen, frisches Grün, lebendige Natur, spring awakening, meadow in bloom"
  },
  {
    short: "Sommerfeld Sonnenblumen, gelb, blauer Himmel",
    full: "an Sonnenblumen-Feld, leuchtend gelb, strahlend blauer Himmel, Sommergefühl, sunflower paradise, summer radiance"
  }
];
